<template>
	<v-app-bar id="app-bar" absolute app   flat height="64" class="bg-secondary">
		<v-btn class="mr-3" elevation="1" fab small @click="setDrawer(!drawer)">
			<v-icon v-if="drawer"> mdi-arrow-left</v-icon>

			 <v-icon v-else> mdi-arrow-right </v-icon>

		</v-btn>

		<v-toolbar-title class="hidden-sm-and-down font-weight-light ">
			<p class="text-h4 ma-0 ml-6" v-html="titleApp"></p>
			</v-toolbar-title>

		<v-spacer />
		<!--
    <v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      style="max-width: 165px;"
    >
      <template
        v-if="$vuetify.breakpoint.mdAndUp"
        v-slot:append-outer
      >
        <v-btn
          class="mt-n2"
          elevation="1"
          fab
          small
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>
-->
		<div class="mx-3" />
		<!--
    <v-btn
      class="ml-2"
      min-width="0"
      text
      to="/"
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>
-->

		<!--<v-menu
			bottom
			left
			offset-y
			origin=" right"
			transition="scale-transition"
		>
			<template v-slot:activator="{ attrs, on }">
				<v-btn
					class="ma-0 pa-0"
					min-width="0"
					text
					v-bind="attrs"
					v-on="on"
					@click="$goBack()"
				>
					<v-icon class="icon-25">mdi-arrow-left</v-icon>
				</v-btn>
			</template>
		</v-menu>-->
    <small class="text-end pr-6" style="font-size:11px;border-right: 1px solid #aaa;">

       <!--  info desde keycloak   -->
      {{ $store.state.user.userInfo.firstName +" "+ $store.state.user.userInfo.lastName }}
       <br>

      <span style="color:#aaa;"  >{{$store.state.user.roles.nombre}}</span>

       <!--  info desde SAP
      {{ $store.state.user.sapProperties.CardName }}<br>

      <span style="color:#aaa;"  >{{$store.state.user.sapProperties.CardCode}}</span>
         -->
    </small>
		<dashboard-core-notification />
		<!--<dashboard-core-settings :menuUser="false" />-->

		<v-menu
			bottom
			left
			offset-y
			origin=" right"
			transition="scale-transition"
		>
			<template v-slot:activator="{ attrs, on }">
				<v-btn class="ml-2 ma-0 pa-0" min-width="0" text v-bind="attrs" v-on="on">

					<v-icon class="icon-25">mdi-cog-outline</v-icon>
				</v-btn>
			</template>
			<v-list :tile="false" nav dense>
				<div>
					<!--<dashboard-core-settings :menuUser="true" />-->
					<router-link to="/perfil" class="text-decoration-none">
						<!--<v-list-item @click="$router.push({ path: '/perfil' })"-->
						<v-list-item
							><v-icon>mdi-account</v-icon
							><span class="mt-1 ml-1">Mi Perfil</span></v-list-item
						>
					</router-link>
					<!--
					<router-link to="/changePassword" class="text-decoration-none">
						<v-list-item
							><v-icon> mdi-cog-outline </v-icon
							><span class="mt-1 ml-1">Cambiar Contraseña</span></v-list-item
						>
					</router-link>
					-->

					<v-list-item href="#" @click="logout()"
						><v-icon>mdi-logout</v-icon
						><span class="mt-1 ml-1">Salir</span></v-list-item
					>
				</div>
			</v-list>
		</v-menu>
    <dialog-confirmar
    v-model="dialogCerrarSesion"
    @input="dialog = $event"
    :info="`¿Esta seguro que desea cerrar la sesión ?`"
    title="Cerrar Sesión"
    icon="mdi-alert-circle-outline"
    color="#F44336"

    @confirm="cerrarSesion()"
  />


	</v-app-bar>
</template>


<script>
	import axios from "axios";
	// Components
	import { VHover, VListItem } from "vuetify/lib";

	// Utilities
	import { mapState, mapMutations } from "vuex";
	import { mapActions, mapGetters } from "vuex";

  import DialogConfirmar from "@/views/dialogs/Confirmar.vue";

	export default {
		name: "DashboardCoreAppBar",

		components: {
      DialogConfirmar,
			AppBarItem: {
				render(h) {
					return h(VHover, {
						scopedSlots: {
							default: ({ hover }) => {
								return h(
									VListItem,
									{
										attrs: this.$attrs,
										class: {
											"black--text": !hover,
											"white--text secondary elevation-12": hover,
										},
										props: {
											activeClass: "",
											dark: hover,
											link: true,
											...this.$attrs,
										},
									},
									this.$slots.default
								);
							},
						},
					});
				},
			},

			DashboardCoreNotification: () => import("./Notifications"),
			DashboardCoreSettings: () => import("./Settings"),
		},

		props: {
			value: {
				type: Boolean,
				default: false,
			},
		},

		data: () => ({
			notifications: [],
			/*items: [{ text: "Profile", icon: "mdi-clock", link: "/pages/user" }],*/
			intervalId: 0,
			titleAppData: "",
			routeNotificaciones: "notificacionesChangeStatus",
      dialogCerrarSesion:false
		}),

		computed: {
			...mapState(["drawer"]),
			...mapGetters({
				isLogged: "authenticated",
			}),
			...mapState("aduana", ["sourceVentaElementosAduanaSt"]),
			titleApp: {
				get() {
					return this.titleAppData || this.$route.meta.titleApp || "";
				},
				set(value) {
					this.titleAppData = value;
				},
			},
		},
		created() {
			let path = this.$route.path;
			if (path[0] == "/") {
				path = path.slice(1);
			}
			let titulo = "";

			let menuTitulo = this.$router.options.routes[0].children.filter(
				(o) => o.path === path
			);

			//console.log(this.$router.options.routes[0].children);
			//console.log(this.$router.options.routes[0].children);
			this.titleApp = menuTitulo[0] ? menuTitulo[0].meta.titleApp + titulo : "";
			/*if(this.isLogged){
																																																																																																																																																																																																																																	      this.getAlertas();
																																																																																																																																																																																																																																	    }*/
		},
		mounted: function () {
			this.intervalId = window.setInterval(() => {
				//console.log('esta logueado: '+this.isLogged);
				if (this.isLogged == true) {
					/*var today = new Date();
																																																																																																																																																																																																																																	          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
																																																																																																																																																																																																																																	          var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
																																																																																																																																																																																																																																	          var dateTime = date+' '+time;*/
					//console.log('consultando alertas: '+dateTime);
					//this.getAlertas();
				} else {
					window.clearInterval(this.intervalId);
				}
			}, 600000); //10 minutos
			//}, 300000) //5 minutos
			//}, 10000)
		},
		methods: {
			...mapActions({
				signOut: "logout",
			}),
			async delay(ms) {
				return new Promise((resolve) => setTimeout(resolve, ms));
			},
			async logout() {


        this.dialogCerrarSesion =true;
				//Swal.alertGetInfo("Cerrando Sesion");
				//await this.delay(1000);

       /* Swal.fire({
						title: "Esta seguro que desea cerrar la sesión?",
						html: "",
						icon: "question",
						showCancelButton: true,
						confirmButtonColor: "#3085d6",
						cancelButtonColor: "#d33",
						confirmButtonText: "Aceptar",
						cancelButtonText: "Cancelar",
						showLoaderOnConfirm: true,
            allowOutsideClick: false,
					}).then((result) => {
						if (result.isConfirmed) {
              this.signOut();//con esto borra el carrito

              sessionStorage.clear();
              this.$keycloak
                .logout(logoutOptions)
                .then((success) => {
                  Swal.close();
                  console.log("--> log: logout success ", success);
                })
                .catch((error) => {
                  Swal.close();
                  console.log("--> log: logout error ", error);
                });
                /*
                const urlKeycloak = process.env.VUE_APP_KEYCLOAK_URL;
                const realm = process.env.VUE_APP_KEYCLOAK_REALM;
                const clientId = process.env.VUE_APP_KEYCLOAK_CLIENTID;
                const redirectUri = encodeURIComponent(window.location.origin);
                const logoutUrl = `${urlKeycloak}/realms/${realm}/protocol/openid-connect/logout?post_logout_redirect_uri=${redirectUri}&client_id=${clientId}`;
                window.location.href = logoutUrl;
                */

            /*

						} else {
						}
					});
        */


				//store.commit("logout");
			},
      async cerrarSesion(){
        await this.signOut();//con esto borra el carrito
        var logoutOptions = { redirectUri: window.location.origin };
        localStorage.clear();
        sessionStorage.clear();
        this.$keycloak
          .logout(logoutOptions)
          .then((success) => {
            Swal.close();
            console.log("--> log: logout success ", success);
          })
          .catch((error) => {
            Swal.close();
            console.log("--> log: logout error ", error);
          });
      },
			async showNotificacion(item, estado) {
				this.changeNotificationStatus(item, estado);
				this.$router.push({ path: item.link });
			},
			async changeNotificationStatus(item, estado) {
				let formData = {
					notificacion_id: item.id,
					usuario_id: this.$store.state.user.id,
					leida: estado,
				};
				this.$axiosApi.post(this.routeNotificaciones, formData).then(
					(response) => {
						console.log(response);
						if (response.status == 200) {
							this.$getNotificaciones();
						} else {
							console.log(response);
						}
					},
					(error) => {
						console.log(error);
					}
				);
			},

			...mapMutations({
				setDrawer: "SET_DRAWER",
			}),
			submit: function () {
				this.$refs.form.submit();
			},
			capitalize(s) {
				if (typeof s !== "string") return "";
				return s.charAt(0).toUpperCase() + s.slice(1);
			},
		},
	};
</script>
